// Angular Imports
import { Component, OnInit, signal } from '@angular/core'
import { Location } from '@angular/common'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
// Angular Material Imports
import { MatButtonModule } from '@angular/material/button'
// This Module Imports
import { ButtonComponent } from '../buttons/button/button.component'

@Component({
	selector: 'app-notfound',
	standalone: true,
	imports: [RouterModule, MatButtonModule, ButtonComponent],
	templateUrl: './notfound.component.html',
	styleUrls: ['./notfound.component.scss'],
})
export class NotfoundComponent implements OnInit {
	buttonText = signal('')
	returnBack: boolean
	redirectTo: string

	constructor(
		private readonly _location: Location,
		private readonly _router: Router,
		private readonly _route: ActivatedRoute
	) {
		this.returnBack = this._route.snapshot.data['returnBack']
		this.redirectTo = this._route.snapshot.data['redirectTo']
	}

	ngOnInit(): void {
		if (this.redirectTo) {
			this.buttonText.set(`Ir atrás - ${this.redirectTo}`)
		} else {
			this.buttonText.set('Ir atrás')
		}
	}

	goBack(): void {
		if (this.returnBack) {
			this._location.back()
		} else {
			this._router.navigate(['/', this.redirectTo])
		}
	}
}
